import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';

import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { SharedModule } from '../shared/shared.module';
import { EventDetailsComponent } from './components/event-details/event-details.component';
import { HomeService } from './services/home.service';
import { AllEventsHomeComponent } from './components/all-events-home/all-events-home.component';


@NgModule({
  declarations: [HomeComponent, EventDetailsComponent, AllEventsHomeComponent],
  imports: [
    CommonModule,
    HomeRoutingModule,
    SharedModule
  ],
  providers: [HomeService, DatePipe]
})
export class HomeModule { }
